export const tokensConstant = {
  AccessToken: "AccessToken",
  RefreshtToken: "RefreshToken"
};

export function getLocalStorageItem(itemName) {
  return localStorage.getItem(itemName);
}

export function setLocalStorageItem(itemName, value) {
  localStorage.setItem(itemName, value);
}
